import React from 'react';
import { RetailCompassStorage } from '@common/utils';
import { IncidentsTable } from './table/IncidentsTable';
import { IncidentsSummary } from './table/IncidentsSummary';
import { HealthChartContainer } from './chart/HealthChartContainer';
import { Card, CardBody } from 'reactstrap';

const HealthReport = () => {
    const incidentsByStoreId = RetailCompassStorage.getIncidents();
    const user = RetailCompassStorage.getUser();
    const productAccess = RetailCompassStorage.getProductAccessConfig();
    const store = user.currentStore;
    const incidents = Object.values(incidentsByStoreId);

    return (
        <div className="wrapper wrapper--full-width">
            <div className="health-report-container">
                <Card>
                    <CardBody>
                        <div className="health-report">
                            <div className="health-report-header">
                                <h2 className="health-report-header__title">
                                    Actualización de datos e incidentes activos
                                </h2>
                                <div className="health-report-header__counters">
                                    <IncidentsSummary incidents={incidents} />
                                </div>
                            </div>
                            <div className="health-report-body">
                                <HealthChartContainer 
                                    store={store}
                                    productAccess={productAccess}
                                />
                                <div className="health-report-body__table">
                                    <IncidentsTable incidents={incidents} />
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </div>
    );
};

export default HealthReport;